/**
 * Invoca internal multi select plugin
 */

import EditableSelectInputView from "shared/controls/editable_select_input_view";
import Select from "shared/select";

import Backbone from "backbone";
import $ from "jquery";

$.fn.multiSelect = function(config) {
  config = config || {};

  var defaultOptions = {
    type: "select",
    width: '250px',
    placeholder: 'Filter by campaign',
    attr:  "id",
    history: true,
    wrapperClass: "select2-wrapper",
    showIdFromNetwork: false,
    select2Options: {}
  };

  var options  = _updateSelect2Options();
  var target   = $(this);

  if (!options.model) {
    var attributes = {};
    attributes[options.attr] = options.defaultValue || target.val();
    attributes[options.attr + "_label"] = options.defaultText;
    options.model = new Backbone.Model(attributes);
  }

  var filter   = new EditableSelectInputView(options);
  var filterEl = filter.render().$el;

  target.html(filterEl);
  return this;

  // private

  function _updateSelect2Options() {
    var currentOptions = $.extend({}, defaultOptions, config);

    if (currentOptions.showIdFromNetwork && !currentOptions.select2Options.templateResult) {
      var select2Options = $.extend({}, currentOptions.select2Options, {
        templateResult: Select.advertiserCampaignTemplateResult
      });

      return $.extend({}, currentOptions, { select2Options: select2Options });
    } else if (currentOptions.showIdFromNetwork && currentOptions.select2Options.templateResult) {
      throw new Error("May not set showIdFromNetwork: true and define custom templateResult in select2Options");
    } else {
      return currentOptions;
    }
  }
};
